import React from 'react';
import { ScopedCssBaseline, ThemeProvider } from '@mui/material';
import withTokenInterceptor from '../hoc/withTokenInterceptor/withTokenInterceptor';
import theme from './theme/theme';

/**
 * Provider do protótipo, para uso DENTRO do abe-web-react.
 *
 * Por que ele é necessário: o `src/main/App.jsx` do projeto não tem nenhum
 * `ThemeProvider`. Os componentes `@mui` de hoje herdam o tema DEFAULT do MUI
 * (primária `#1976d2`). Sem envolver as telas do protótipo num
 * `ThemeProvider`, o azul marinho `#0d2b52` e todos os overrides do tema
 * simplesmente não se aplicam.
 *
 * Por que `ScopedCssBaseline` e não `CssBaseline`: o `CssBaseline` escreve
 * regras no `body` e no `*`. Montado dentro do app existente, ele mudaria
 * background, tipografia e scrollbar de TODAS as telas atuais. O
 * `ScopedCssBaseline` aplica o mesmo reset apenas na subárvore, então as telas
 * legadas ficam intactas.
 *
 * Por que `withTokenInterceptor` aqui: `RoutesPrototipo.jsx` monta fora de
 * `<LayoutNavigation>` (de propósito, para não duplicar a navegação lateral) —
 * `SideDrawerNavigation`, único lugar que registra o interceptor Axios que
 * injeta o header `Authorization`, nunca monta em `/prototipo/*`. Sem isso,
 * toda chamada real a `gateway`/`services` feita de dentro do protótipo sai
 * sem token e o backend responde 401 (`InsufficientAuthenticationException`).
 * Mesmo padrão já usado por `LoginPage` (`Login.cont.jsx`), que está na mesma
 * posição estrutural em `Routes.jsx` (fora de `LayoutNavigation`).
 */
function PrototipoProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline sx={{ backgroundColor: 'transparent' }}>
        {children}
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}

export default withTokenInterceptor(PrototipoProvider);
